<template>
  <BCard>
    <slot name="title">
      <span class="headline">{{ $t(`userManagement.title`) }}</span>
    </slot>
    <div class="container">
      <div class="mb-500">
        <BInput
          v-model="inputName"
          v-model:valid="valid"
          :label="$t(`userManagement.name`)"
          :rules="[requiredRule]"
        />
      </div>
      <div class="mb-500">
        <BInput
          v-model="inputLastName"
          v-model:valid="valid"
          :label="$t(`userManagement.lastName`)"
          :rules="[requiredRule]"
        />
      </div>
      <div class="mb-500">
        <BInput
          v-model="inputFirstName"
          v-model:valid="valid"
          :label="$t(`userManagement.firstName`)"
          :rules="[requiredRule]"
        />
      </div>
      <div class="mb-500">
        <BInput
          v-model="inputEmail"
          v-model:valid="emailValid"
          :label="$t(`userManagement.email`)"
          :rules="[requiredRule, firebaseEmailRule]"
        />
      </div>
      <div class="mb-500">
        <BSelect
          v-model="inputRole"
          :label="$t(`userManagement.role`)"
          :items="roles"
          item-text="text"
          item-value="value"
          fit
        />
      </div>
      <div class="mb-500">
        <BCheckbox
          v-model="inputActivated"
          :label="$t(`userManagement.activated`)"
          color="focus"
        />
      </div>
    </div>
    <slot name="actions">
      <BLayout
        align-center
        justify-center
      >
        <BBtn
          class="mr-400"
          text
          @click="cancel"
        >
          {{ $t(`general.cancel.text`) }}
        </BBtn>
        <BBtn
          class="ml-400"
          type="primary"
          :disabled="!valid || !emailValid"
          :loading="loading"
          @click="save"
        >
          {{ $t(`general.save.text`) }}
        </BBtn>
      </BLayout>
    </slot>
  </BCard>
</template>

<script>
import { useInputValidations } from '@/composable/input-validations';

export default {
  props: {
    name: String,
    lastName: String,
    firstName: String,
    email: String,
    role: String,
    activated: String,
    loading: Boolean,
  },
  emits: [
    'save',
    'cancel',
  ],
  setup() {
    const { requiredRule, firebaseEmailRule } = useInputValidations();
    return { requiredRule, firebaseEmailRule };
  },
  data () {
    return {
      valid: false,
      emailValid: true, // NOTE: 他の入力欄のvalidに上書きされないよう個別に持つ。BInputが検証するまでは編集前の値として有効扱い
      inputName: null,
      inputLastName: null,
      inputFirstName: null,
      inputEmail: null,
      inputRole: null,
      inputActivated: null,
      roles: [
        { text: this.$t('user.enum.owner'), value: 'owner' },
        { text: this.$t('user.enum.member'), value: 'member' },
        { text: this.$t('user.enum.bpo_guest'), value: 'bpo_guest' },
      ],
    };
  },
  watch: {
    name (newVal) {
      this.inputName = newVal;
    },
    lastName (newVal) {
      this.inputLastName = newVal;
    },
    firstName (newVal) {
      this.inputFirstName = newVal;
    },
    email (newVal) {
      this.inputEmail = newVal;
    },
    role (newVal) {
      this.inputRole = newVal;
    },
    activated (newVal) {
      this.inputActivated = this.convertActivated(newVal);
    },
  },
  created () {
    this.reset();
  },
  methods: {
    async save () {
      let confirmEmailChange = true;

      if (!this.valid || !this.emailValid) return;
      if (this.email != this.inputEmail) {
        confirmEmailChange = await this.$bitterAlert.show({
          title: this.$t('general.confirm.text'),
          text: this.$t('auth.changeEmailMessage'),
        });
      }

      if (!confirmEmailChange) {
        this.$emit('cancel');
        return;
      }

      const user = {
        name: this.inputName,
        lastName: this.inputLastName,
        firstName: this.inputFirstName,
        email: this.inputEmail,
        role: this.inputRole,
        activated: this.inputActivated,
      };
      this.$emit('save', user);
    },
    cancel () {
      this.$emit('cancel');
    },
    reset () {
      this.inputName = this.name;
      this.inputLastName = this.lastName;
      this.inputFirstName = this.firstName;
      this.inputEmail = this.email;
      this.inputRole = this.role;
      this.inputActivated = this.convertActivated(this.activated);
    },
    convertActivated (activated) {
      if (activated === 'disabled') {
        return false;
      } else if (activated === 'enabled') {
        return true;
      } else {
        return null;
      }
    },
  },
};
</script>
